import {contractsService} from 'services';

export const SET_CURRENT_CONTRACT = 'SET_CURRENT_CONTRACT';
export const SET_CURRENT_CONTRACT_ID = 'SET_CURRENT_CONTRACT_ID';

const contractStore = {
  namespaced: true,
  state () {
    return {
      currentContract: null
    };
  },
  getters: {
    currentContract: (state) => state.currentContract
  },
  mutations: {
    [SET_CURRENT_CONTRACT] (state, contract) {
      state.currentContract = contract;
    }
  },
  actions: {
    async [SET_CURRENT_CONTRACT_ID] (context, contractId) {
      if (!contractId) {
        context.commit(SET_CURRENT_CONTRACT, null);
        return;
      }
      const contract = await contractsService.getContract(context.rootGetters['accounts/currentAccount'].id, contractId);
      context.commit(SET_CURRENT_CONTRACT, contract);
    }
  }
};

export default contractStore;
